import React from "react";
import { Link } from "react-router-dom";
import { Box, Chip, styled } from "@mui/material";

/* Responsive Wrapper */
const TabsWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flexWrap: "nowrap",          // prevent wrapping on small screens
    overflowX: "auto",           // enable horizontal scroll
    overflowY: "hidden",
    whiteSpace: "nowrap",
    gap: "12px",
    padding: "0 20px 20px 20px",
    width: "100%",
    scrollbarWidth: "none",      // hide scrollbar (Firefox)
    msOverflowStyle: "none",     // hide scrollbar (IE/Edge)
    "&::-webkit-scrollbar": {
        display: "none",           // hide scrollbar (Chrome/Safari)
    },

    /* On medium+ screens: center and allow wrapping */
    [theme.breakpoints.up("md")]: {
        flexWrap: "wrap",
        justifyContent: "center",
        overflowX: "visible",
        whiteSpace: "normal",
    },
}));

/* Styled Chip */
const TabChip = styled(Chip)(({ theme }) => ({
    px: 20,
    py: 10,
    fontWeight: 700,
    fontSize: "0.9rem",
    borderRadius: "999px",
    cursor: "pointer",
    transition: "0.25s ease",
}));

/* Default Tabs */
const defaultLanguageTabs = [
    { label: "Java", to: "/javadashboard" },
    { label: "Java Algorithm Prep", to: "/java-algorithms" },
    { label: "C++", to: "/cpp-dashboard" },
    { label: "C++ Algorithms Prep", to: "/cpp-algorithms" },
    { label: "JavaScript", to: "/javascriptcoding" },
    { label: "JavaScript Algorithms Prep", to: "/javascript-algorithms" },
    { label: "Python", to: "/pythonCodingDashBoard" },
    { label: "Python Algorithms Prep", to: "/python-algorithms" },
    { label: "TypeScript", to: "/typescript-dashboard" },
    { label: "Linux", to: "/linux-dashboard" },
    { label: "Express.Js", to: "/express-dashboard" },
    { label: "Spring Boot", to: "/springboot-dashboard" },
    { label: "IoT", to: "/iot-dashboard" },
];

/**
 * Reusable Language Tabs Component
 * Props:
 * - active: string (label of active tab)
 * - tabs: optional custom tab list (fallback to defaultLanguageTabs)
 */
export default function LanguageTabs({ active, tabs = defaultLanguageTabs }) {
    return (
        <TabsWrapper>
            {tabs.map((tab) => (
                <Link key={tab.to} to={tab.to} style={{ textDecoration: "none" }}>
                    <TabChip
                        label={tab.label}
                        sx={{
                            backgroundColor:
                                tab.label === active
                                    ? "goldenrod"
                                    : "rgba(255,255,255,0.12)",
                            color: tab.label === active ? "#100720" : "white",
                            "&:hover": {
                                backgroundColor:
                                    tab.label === active
                                        ? "#e0b200"
                                        : "rgba(255,255,255,0.25)",
                            },
                        }}
                    />
                </Link>
            ))}
        </TabsWrapper>
    );
}
